export default __webpack_public_path__ + "static/floatingImg6-db702e0a85fb7f54ec320c2261d39541.webp";